/*###########################################################################
// Full Width Image
//#########################################################################*/

import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

const fullWidthImage = {
	config: {
		opacityIn: '.opacityIn',
		fullWidthImageBg: '.fullWidthImageBg',
		opacityInImage: '.opacityInImage',
	},

	elements: {},

	init() {
		const self = this

		self.elements.opacityIn = document.querySelectorAll(self.config.opacityIn)
		if (self.elements.opacityIn !== null) {
			for (let i = 0; i < self.elements.opacityIn.length; i++) {
				const opacityIn = self.elements.opacityIn[i]

				self.handleOpacityIn(opacityIn)
			}
		}
	},

	handleOpacityIn(opacityIn) {
		const self = this

		if (opacityIn !== null) {
			const backgroundElement = opacityIn.querySelector(self.config.fullWidthImageBg)
			const opacityInImage = opacityIn.querySelector(self.config.opacityInImage)
			const topSide = opacityIn.querySelector("#top-side")
			const leftSide = opacityIn.querySelector("#left-side")
			const rightSide = opacityIn.querySelector("#right-side")
			const bottomSide = opacityIn.querySelector("#bottom-side")

			if (backgroundElement) {
				const tlOpacityIn = gsap.timeline({
					scrollTrigger: {
						trigger: opacityIn,
						start: "top center",
						end: "top bottom"
					}
				})

				tlOpacityIn.to(backgroundElement, {
					duration: 1.25,
					opacity: 0,
					ease: "power1.out",
				})

				tlOpacityIn.to(opacityInImage, {
					duration: 1.25,
					blur: 0,
					ease: "power1.out",
				} , "-=1.25")

				tlOpacityIn.to(topSide, {
					duration: 0.75,
					width: "100%",
					ease: "power1.out",
				} , "-=0.75")

				tlOpacityIn.to(rightSide, {
					duration: 0.75,
					height: "100%",
					ease: "power1.out",
				})

				tlOpacityIn.to(bottomSide, {
					duration: 0.75,
					width: "100%",
					ease: "power1.out",
				})

				tlOpacityIn.to(leftSide, {
					duration: 0.75,
					height: "100%",
					ease: "power1.out",
				})

			}
		}
	}
}

initComponent(() => {
	fullWidthImage.init()
})
